import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';

import { templates } from '~/constants/queryParams';
import { useAppDispatch } from '~/hooks/useRedux';
import CouponTemplate from '~/pages/CreateQR/sub-components/couponTemplate/CouponTemplate';
import VideoTemplate from '~/pages/CreateQR/sub-components/videoTemplate/VideoTemplate';
import { getStepperData } from '~/store/reducers/stepepr/selectors';
import { isRequiredFieldPresent } from '~/utils/common';
import { useErrorClassObserver } from '~/utils/hooks';

import AppsTemplate from '../sub-components/appsTemplate/AppsTemplate';
import ImagesTemplate from '../sub-components/imagesTemplate/ImagesTemplate';
import ListOfLinksTemplate from '../sub-components/listOfLinksTemplate/ListOfLinksTemplate';
import PDFTemplate from '../sub-components/pdfTemplate/PDFTemplate';
import SocialsTemplate from '../sub-components/socialsTemplate/SocialsTemplate';
import VCardTemplate from '../sub-components/vCardTemplate/VCardTemplate';
import WebsiteTemplate from '../sub-components/WebsiteTemplate';

export default function CreateQrEditorStep() {
  const dispatch = useAppDispatch();
  const { isMicrositeDataValid } = useSelector(getStepperData);

  const [searchParams] = useSearchParams();
  const step = searchParams.get('template');
  const isErrorClass = useErrorClassObserver();

  useEffect(() => {
    isRequiredFieldPresent(dispatch, isMicrositeDataValid);
  }, [isErrorClass]);

  let content;

  switch (templates.indexOf(step)) {
    case 0:
      content = <WebsiteTemplate />;
      break;
    case 1:
      content = <PDFTemplate />;
      break;
    case 2:
      content = <ListOfLinksTemplate />;
      break;
    case 3:
      content = <AppsTemplate />;
      break;
    case 4:
      content = <ImagesTemplate />;
      break;
    case 5:
      content = <VCardTemplate />;
      break;
    case 6:
      content = <SocialsTemplate />;
      break;
    case 7:
      content = <CouponTemplate />;
      break;
    case 8:
      content = <VideoTemplate />;
      break;
    default:
      content = null;
  }

  return <Box sx={{ paddingBottom: '30px', flex: 1 }}>{content}</Box>;
}
